module.exports = __webpack_public_path__ + "Roboto-Bold.705c26e87b9216e0d0e8.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/assets/font/roboto/Roboto-Bold.woff
// module id = ../../../../../src/assets/font/roboto/Roboto-Bold.woff
// module chunks = 2